import { useMfaSetupSheet } from '@/components/mfa-setup-sheet';
import { ErrorSidePanel } from '@/components/errors';
import { getMobilePlatform, isAppleDevice, loadHistoryState } from '@/lib';
import {
  ErrorCodes,
  ModuleName,
  Screen,
  type SkinPageConfig,
  templates,
} from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { type AuthenticatorApp, mfaSetupFlowSchema } from '../../../-model/flow';
import { type DownloadAppProps } from './-model/props';
import { DownloadAppLight } from './-skins';

const KEY_PREFIX = 'Security.AuthenticatorAppCard.Setup.DownloadApp';

export const Route = createFileRoute(
  '/(security)/security/_mfa-setup/authenticator-app/download-app/',
)({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
  staticData: {
    module: ModuleName.Security,
    screen: Screen.SetupLandingPage,
    setupStep: {
      number: 1,
      titleKey: `${KEY_PREFIX}.Title`,
      subtitleKey: `${KEY_PREFIX}.Description`,
    },
  },
  loader: loadHistoryState(mfaSetupFlowSchema, { errorCode: ErrorCodes.AccessDenied }),
});

function RouteComponent() {
  const setup = Route.useLoaderData();
  const navigate = Route.useNavigate();
  const { setSubView } = useMfaSetupSheet();
  const [selected, setSelected] = useState<AuthenticatorApp | null>(null);
  const [qrCodeOpen, setQrCodeOpen] = useState(false);

  const closeQrCode = () => {
    setQrCodeOpen(false);
    setSubView(null);
  };

  const props: DownloadAppProps = {
    selected,
    select: setSelected,
    platform: getMobilePlatform(),
    isApple: isAppleDevice(),
    qrCodeOpen,
    openQrCode: () => {
      setQrCodeOpen(true);
      setSubView({ onBack: closeQrCode });
    },
    goToRegister: () => {
      if (!selected) return;
      navigate({
        to: '/security/authenticator-app/register',
        state: { ...setup, SelectedApp: selected },
      });
    },
  };

  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: DownloadAppProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <DownloadAppLight {...props} />,
  };
}
